var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapConsumer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var projection = ref.projection;
return [_c('g',{style:(_vm.computedStyle),attrs:{"transform":_vm.getTransform(projection)},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"click":_vm.onMouseUp}},[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }